var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import IconButton from "@mui/material/IconButton";
import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";
import { spacing } from "../../../theme";
var StyledIconButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", "px;\n"], ["\n  margin: ", "px;\n"])), spacing / 2);
var AppIconButton = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, _b = _a.size, size = _b === void 0 ? 40 : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, rest = __rest(_a, ["icon", "onClick", "size", "isLoading"]);
    return (_jsx(StyledIconButton, __assign({ onClick: onClick }, rest, { style: { height: size, width: size } }, { children: isLoading ? _jsx(CircularProgress, {}) : icon })));
};
export { AppIconButton };
var templateObject_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwSWNvbkJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3VpL0FwcEljb25CdXR0b24vQXBwSWNvbkJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxVQUFVLE1BQU0sMEJBQTBCLENBQUM7QUFDbEQsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFDckMsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQ2pELE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUV6QyxJQUFNLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUMsMEZBQUEsY0FDL0IsRUFBVyxPQUN0QixLQURXLE9BQU8sR0FBRyxDQUFDLENBQ3RCLENBQUM7QUFTRixJQUFNLGFBQWEsR0FBRyxVQUFDLEVBQTRFO0lBQTFFLElBQUEsSUFBSSxVQUFBLEVBQUUsT0FBTyxhQUFBLEVBQUUsWUFBUyxFQUFULElBQUksbUJBQUcsRUFBRSxLQUFBLEVBQUUsaUJBQWlCLEVBQWpCLFNBQVMsbUJBQUcsS0FBSyxLQUFBLEVBQUssSUFBSSxjQUF0RCx3Q0FBd0QsQ0FBRjtJQUF3QyxPQUFBLENBQ25ILEtBQUMsZ0JBQWdCLGFBQUMsT0FBTyxFQUFFLE9BQU8sSUFBTSxJQUFJLElBQUUsS0FBSyxFQUFFLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLGdCQUMvRSxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUMsZ0JBQWdCLEtBQUcsQ0FBQyxDQUFDLENBQUMsSUFBSSxJQUN2QixDQUNwQixDQUFBO0NBQUEsQ0FBQztBQUVGLE9BQU8sRUFBRSxhQUFhLEVBQUUsQ0FBQyJ9